import { Controller } from "@hotwired/stimulus"

// Enables the Compare button only when the checkbox count is within [min, max].
// Default min=2, max=3 (Cross-Plant Comparison UX).
export default class extends Controller {
  static targets = ["checkbox", "button", "hint"]
  static values = { min: { type: Number, default: 2 }, max: { type: Number, default: 3 } }

  connect() {
    this.update()
  }

  update() {
    const checked = this.checkboxTargets.filter(c => c.checked).length
    const valid = checked >= this.minValue && checked <= this.maxValue

    // Enforce max: if user tries to check beyond max, uncheck the latest
    if (checked > this.maxValue) {
      this.checkboxTargets.filter(c => c.checked).slice(this.maxValue).forEach(c => c.checked = false)
      return this.update()
    }

    this.buttonTarget.disabled = !valid
    if (this.hasHintTarget) {
      if (checked < this.minValue) {
        this.hintTarget.textContent = `Select at least ${this.minValue} plants to compare`
        this.hintTarget.classList.remove("hidden")
      } else if (checked >= this.maxValue) {
        this.hintTarget.textContent = `Max ${this.maxValue} plants`
        this.hintTarget.classList.remove("hidden")
      } else {
        this.hintTarget.classList.add("hidden")
      }
    }
  }
}
